export const locale = {
  lang: 'fr',
  data: {
    MENU: {
      HOME: 'Upload',
      SAMPLE: 'Geocode',
      PROFILE: 'Profile',
      HISTORY: 'History'
    }
  }
}
